import { render, staticRenderFns } from "./IndividualsTable.vue?vue&type=template&id=1e89a9a1&scoped=true&"
import script from "./IndividualsTable.vue?vue&type=script&lang=js&"
export * from "./IndividualsTable.vue?vue&type=script&lang=js&"
import style0 from "./IndividualsTable.vue?vue&type=style&index=0&id=1e89a9a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e89a9a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDataTable,VIcon,VRow,VTextField})
